export function getOrganizationSlug():
  string | null {
  const match = window.location.pathname.match(
    /^\/o\/([a-z0-9-]+)/
  );

  return match?.[1] ?? null;
}

export function goToCamp(
  slug: string
): void {
  window.history.pushState(
    {},
    "",
    `/o/${slug}`
  );
  window.dispatchEvent(
    new PopStateEvent("popstate")
  );
}
